import { colors } from '@lmc/common/constants'
import styled from 'styled-components'

type PopoverTextBoxProps = {
  carerName?: { first: string; last: string }
  details?: string
  onClick?: () => void
  timestamp?: string
  title?: string
}

export default function PopoverTextBox({
  carerName,
  details,
  onClick,
  timestamp,
  title
}: PopoverTextBoxProps) {
  return (
    <ContainerDiv onClick={onClick}>
      {timestamp && (
        <GreyText>
          {`${timestamp} • ${carerName?.first} ${carerName?.last}`}
        </GreyText>
      )}
      <Title className="log-title">{title}</Title>
      <Details>{details}</Details>
    </ContainerDiv>
  )
}

const ContainerDiv = styled.div`
  background-color: ${colors.white};
  border-radius: 4px;
  box-shadow: 0 1px 3px hsla(0, 0%, 0%, 0.1), 0 -1px 3px hsla(0, 0%, 0%, 0.1);
  padding: 8px;
  text-align: left;
  &:hover {
    cursor: pointer;
  }
  &:hover .log-title {
    text-decoration: underline;
    text-decoration-color: ${colors.pink};
  }
`

const Details = styled.div`
  color: ${colors.black};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`

const GreyText = styled.div`
  color: ${colors.darkgrey};
  font-size: 12px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`

const Title = styled.div`
  color: ${colors.black};
  font-size: 16px;
  font-weight: bold;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`
